export const RDBMS = "RDBMS";
